module.exports = __webpack_public_path__ + "static/media/apng_rudo.c2045994.png";